import React, { useState, useEffect } from 'react';

import { PopupWrapper } from '../styles/drag-message-popup';

const imagePath = 'images/drag-message.png';
const timeoutSeconds = 5;

export default function DragMessagePopup() {

  const [ isVisible, setVisible ] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isVisible) {
        setVisible(false);
      }
    }, timeoutSeconds * 1000);

    return () => clearInterval(interval);
  }, [isVisible]);

  if (isVisible) {
    return (
      <PopupWrapper onClick={() => setVisible(false)} >
        <img src={imagePath} />
      </PopupWrapper>
    );
  }
  else {
    return null;
  }
}